import * as occlTemplates from '@mfe/components/templates/occl';

export type TemplateTheme = 'occl'; // | "tefOne"
export type TemplateNames = keyof typeof occlTemplates;

let resolverInstance: TemplateResolver | null;

const templates = {
  occl: occlTemplates,
};

export default class TemplateResolver {
  private theme: TemplateTheme;

  private constructor(theme: TemplateTheme) {
    this.theme = theme;
  }

  resolve<TN extends TemplateNames>(templateName: TN): typeof occlTemplates[TN] {
    const themedTemplates = templates[this.theme];
    const template = themedTemplates[templateName];
    if (!template) {
      throw new Error(`Could not find template 'src/components/templates/${this.theme}/${templateName}.tmpl.ts'`);
    }
    return template;
  }

  static getInstance(theme: TemplateTheme = 'occl') {
    if (!resolverInstance) {
      resolverInstance = new TemplateResolver(theme);
    }
    return resolverInstance;
  }

  static clear() {
    resolverInstance = null;
  }
}
